import { render, staticRenderFns } from "./dictInfo.vue?vue&type=template&id=4d58d52f&scoped=true&"
import script from "./dictInfo.vue?vue&type=script&lang=js&"
export * from "./dictInfo.vue?vue&type=script&lang=js&"
import style0 from "./dictInfo.vue?vue&type=style&index=0&id=4d58d52f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d58d52f",
  null
  
)

export default component.exports